import React, {useRef, useState, useEffect} from 'react';
import "./Preview.css";

import MapItButton from '../../Common/MapItButton/MapItButton';
import { Link } from 'react-router-dom';
import {isMobile, isMobileOnly} from 'react-device-detect'
import Footer from '../../Common/Footer/Footer';
// import ImageGallery from "react-image-gallery";
import {Helmet} from "react-helmet";
import PageTitle from '../../Common/PageTitle/PageTitle';

import left from '../../../Assets/left-arrow.png';
import right from '../../../Assets/right-arrow.png';
import leftBlue from '../../../Assets/left-arrow-blue.png';
import rightBlue from '../../../Assets/right-arrow-blue.png';

const Preview = ({fpType, 
  fpBase64, 
  floorplan, 
  fpWidth, 
  fpHeight, 
  ssObjs, 
  setPreview, 
  snapSize, 
  setSharePressed, 
  coordMap, 
  galMap,
  selectedCoord,
  setSelectedCoord,
  mapOfX,
  sortedByX}) => {
  const [selectedSS, setSelectedSS] = useState(0);
  const [winX, setWinX] = useState(window.innerWidth);
  const [winY, setWinY] = useState(window.innerHeight);
  const [fpX, setFpx] = useState(((winX - (fpWidth*winX))/2)/winX);
  const [fpY, setFpy] = useState(((winY - (fpHeight*winY))/2)/winY);
  const galRef = useRef();
  const selectedCoordRef = useRef(selectedCoord);
  const selectedSSRef = useRef(selectedSS);
  const ssObjsRef = useRef(ssObjs);

  const horizontalTab = (isMobile && window.innerWidth>window.innerHeight)?true:false;

  const deviceFpRatio = (isMobile&&!horizontalTab) ? 1:0.8;
  const deviceSsRatio = (isMobile&&!horizontalTab) ? 0.9:0.4;
  const deviceSnapRatio = (isMobileOnly) ? 1.5:1;

  useEffect(() => {
    const handleResize = () => {
        setWinX(window.innerWidth);
        setWinY(window.innerHeight);
    };

    const closePopup = (e) => {
      if (galRef.current && !galRef.current.contains(e.target)) {
        setSelectedSS(0);
        console.log(`doubleclickref ${selectedSSRef.current}`);
        console.log("ssobjs in closeup");
        console.log(ssObjsRef.current);
        const ss = ssObjsRef.current[selectedSSRef.current];
        console.log("ss obj in closepopup");
        console.log(ss);
        selectedCoordRef.current[`coordX: ${ss.coordinatex} coordY: ${ss.coordinatey}`] = 0;
        setSelectedCoord({...selectedCoordRef.current});
      }
    };

    document.body.addEventListener('mousedown', closePopup);
    window.addEventListener('resize', handleResize);
    return () => {
      document.body.removeEventListener('mousedown', closePopup);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(()=>{
    ssObjsRef.current = ssObjs;
  },[ssObjs]);

  useEffect(()=> {
    selectedSSRef.current = selectedSS;
  },[selectedSS]);

  useEffect(()=>{
    selectedCoordRef.current = selectedCoord;
  },[selectedCoord]);

  const imageClick = (ssId) => {
    const ss = ssObjs[ssId];
    setSelectedSS(ssId);
    if (ss.coordinatex != 0 || ss.coordinatey != 0) {
      setSelectedCoord({...selectedCoord, [`coordX: ${ss.coordinatex} coordY: ${ss.coordinatey}`]: 1});
    }
  }

  const getFpImageSrc = (base64, file) => {
    let imgSrc = "";
    if (base64) {
      switch (fpType) {
        case "png":
          imgSrc = "data:image/png;base64," + base64;
          break;
        case "jpeg":
          imgSrc = "data:image/jpeg;base64," + base64;
          break;
        default:
          break;
      }
      return imgSrc;
    } else {
      return "https://d1se9yqadop5at.cloudfront.net/" + file;
    }
  }

  const onBackFp = () => {
    setSelectedSS(0);
    setSharePressed(true);
    setPreview(false);
  }

  const leftOrRight = (ssId, width) => {
    if (((fpX*winX) + (ssObjs[ssId].coordinatex*fpWidth*winX) + ssObjs[ssId].renderWidth*winX*0.4)
    > (fpX*winX+(fpWidth*winX))) {
      return -1*ssObjs[ssId].renderWidth*winX*0.4+(fpWidth*winX*snapSize); // magic number 0.4? - hard type this
    } else {
      return 0;
    }
  }

  const topOrBottom = (ssId, height) => {
    if (((fpY*winY) + (ssObjs[ssId].coordinatey*fpHeight*winY) + ssObjs[ssId].renderHeight*winY*0.4)
    > (fpY*winY+(fpHeight*winY))) {
      return -1*ssObjs[ssId].renderHeight*winY*0.4+(fpWidth*winX*snapSize);
    } else {
      return 0;
    }
  }

  const getSnapshotCountStyle = (ssId) => {
    if (ssObjs[ssId].coordinatex !== 0 || ssObjs[ssId].coordinatey !== 0) {
      return {position: 'absolute', color: "white", 
      backgroundColor: "red", 
      border: "1px solid red", 
      borderRadius:"50%",
      left: (ssObjs[ssId].coordinatex*fpWidth*winX),
      top: (ssObjs[ssId].coordinatey*fpHeight*winY)
      };
    } else {
      return {};
    }
  }

  const getSnapshotStyle = (ssId) => {
    let borderTopRight = false;
    let borderTopLeft = false;
    let borderBottomRight = false;
    let borderBottomLeft = false;
    if (ssId==selectedSS) {
      const leftOrRightVal = leftOrRight(ssId);
      const topOrBottomVal = topOrBottom(ssId);
      if (leftOrRightVal && topOrBottomVal) {
        borderBottomRight = true;
      } else if (leftOrRightVal) {
        borderTopRight = true;
      } else if (topOrBottomVal) {
        borderBottomLeft = true;
      } else {
        borderTopLeft = true;
      }
    }
    if (ssObjs[ssId].coordinatex !== 0 || ssObjs[ssId].coordinatey !== 0) {
      if (selectedCoord[`coordX: ${ssObjs[ssId].coordinatex} coordY: ${ssObjs[ssId].coordinatey}`] == 0) {
        return {position: 'absolute', 
        left: (ssObjs[ssId].coordinatex*fpWidth*winX),
        top: ((ssObjs[ssId].coordinatey*fpHeight*winY)),
        borderRadius: "50%"
        };
      } else {
        return {position: 'absolute', 
        left: ((ssObjs[ssId].coordinatex*fpWidth*winX) + leftOrRight(ssId)), 
        top: ((ssObjs[ssId].coordinatey*fpHeight*winY) + topOrBottom(ssId)),
        borderBottomLeftRadius:borderBottomLeft?'0px':'20px',
        borderBottomRightRadius:borderBottomRight?'0px':'20px',
        borderTopLeftRadius:borderTopLeft?'0px':'20px',
        borderTopRightRadius:borderTopRight?'0px':'20px'
        };
      }
    } else {
      return {};
    }
  }

  const getSSWidth = (ssId) => {
    let ssWidth = 0;
    let ss = ssObjs[ssId];
    if (ssObjs[ssId].coordinatex != 0 || ssObjs[ssId].coordinatey != 0) {
      if (ssId == selectedSS || selectedCoord[`coordX: ${ss.coordinatex} coordY: ${ss.coordinatey}`] == 1) {
        ssWidth = ssObjs[ssId].renderWidth*winX*0.4;
      } else {
        ssWidth = fpWidth*winX*snapSize;
      }
    }
    return ssWidth;
  }

  const getSSHeight = (ssId) => {
    let ssHeight = 0;
    let ss = ssObjs[ssId];
    if (ssObjs[ssId].coordinatex != 0 || ssObjs[ssId].coordinatey != 0) {
      if (ssId == selectedSS || selectedCoord[`coordX: ${ss.coordinatex} coordY: ${ss.coordinatey}`] == 1) {
        ssHeight = ssObjs[ssId].renderHeight*winY*0.4;
      } else {
        ssHeight = fpWidth*winX*snapSize; // using width here is correct to make square icons
      }
    }
    return ssHeight;
  }
  
  const onLargeImageClick = (ssId) => {
    const ss = ssObjs[ssId];
    setSelectedSS(0);
    if (ss.coordinatex != 0 || ss.coordinatey != 0) {
      setSelectedCoord({...selectedCoord, [`coordX: ${ss.coordinatex} coordY: ${ss.coordinatey}`]: 0});
    }  
  }

  function slideLeft() {
    const curIdx = mapOfX[selectedSS];
    console.log(selectedSS);
    // console.log(mapOfX);
    // console.log(sortedByX);
    let newIdx = curIdx + 1;
    if (newIdx > sortedByX.length-1) {
      newIdx = 0;
    }
    const newSSId = sortedByX[newIdx].snapshot_id;
    let ss = ssObjs[newSSId];
    let oldSS = ssObjs[selectedSS];
    if (selectedCoord[`coordX: ${ss.coordinatex} coordY: ${ss.coordinatey}`] === 0 ) {
      selectedCoord[`coordX: ${oldSS.coordinatex} coordY: ${oldSS.coordinatey}`] = 0;
      selectedCoord[`coordX: ${ss.coordinatex} coordY: ${ss.coordinatey}`] = 1;
      setSelectedCoord({...selectedCoord});
    }
    // console.log(ssObjs);
    console.log(newSSId);
    // console.log(selectedCoord)
    setSelectedSS(newSSId);
  }

  function slideRight() {
    const curIdx = mapOfX[selectedSS];
    console.log(curIdx);
    let newIdx = curIdx -1;
    if (newIdx < 0) {
      newIdx = sortedByX.length-1;
    }
    const ss = sortedByX[newIdx];
    const newSSId = ss.snapshot_id;
    const oldSS = sortedByX[curIdx];
    if (selectedCoord[`coordX: ${ss.coordinatex} coordY: ${ss.coordinatey}`] === 0 ) {
      selectedCoord[`coordX: ${oldSS.coordinatex} coordY: ${oldSS.coordinatey}`] = 0;
      selectedCoord[`coordX: ${ss.coordinatex} coordY: ${ss.coordinatey}`] = 1;
      setSelectedCoord({...selectedCoord});
    }
    console.log(newSSId);
    setSelectedSS(newSSId);
  }

  const getLeftArrowStyle = (ssId) => {
    let width = getSSWidth(ssId);
    let height = getSSHeight(ssId);
    let arrowWidth = width*0.15;
    let arrowHeight = arrowWidth*1.74;
    return {position: 'absolute',
    width: arrowWidth,
    height: height,
    left: ((fpX*winX) + (ssObjs[ssId].coordinatex*fpWidth*winX) + leftOrRight(ssId,width)), 
    top: ((fpY*winY) + (ssObjs[ssId].coordinatey*fpHeight*winY) + topOrBottom(ssId,height)),
    };
  }
  const getRightArrowStyle = (ssId) => {
    let width = getSSWidth(ssId);
    let height = getSSHeight(ssId);
    let arrowWidth = width*0.15;
    let arrowHeight = arrowWidth*1.74;
    return {position: 'absolute',
    width: arrowWidth,
    height: height,
    left: ((fpX*winX) + (ssObjs[ssId].coordinatex*fpWidth*winX) + leftOrRight(ssId,width) + (width) - arrowWidth), 
    top: ((fpY*winY) + (ssObjs[ssId].coordinatey*fpHeight*winY) + topOrBottom(ssId,height)),
    };
  }

  const ArrowKeyDetector = (event) => {
    switch(event.key) {
      case 'ArrowRight':
        console.log("arrow right")
        slideLeft();
        break;
      case 'ArrowLeft':
        console.log("arrow left")
        slideRight();
        break;
      default:
        console.log(event.key)
        break;
    }
  }

  const getImageSrc = (ssObj) => {
    if (ssObj.image) {
      // console.log(`ss base64 path: ${ssObj.snapshot_id}`)
      let base64Token = "";
      switch(ssObj.fileType) {
        case "jpeg":
          base64Token = "data:image/jpeg;base64,";
          break;
        case "png":
          base64Token = "data:image/png;base64,";
          break;
      }
      return base64Token + ssObj.image;
    } else {
      // console.log(`ss remote path: ${ssObj.remote_file_path}`)
      return "https://d1se9yqadop5at.cloudfront.net/" + ssObj.remote_file_path
    }
  }

  function Logo () {
    return (
      <div className="preview-header">
        <div className="preview-logo">
          <img src="https://d13dvi4jdbb8bg.cloudfront.net/MapIt-Logo-768x292px.png" width="157.81vh" height="60vh"/>
        </div>
        <div className="preview-back-btn">
          <Link className="Link-style" to="/create" spy={true} smooth={true}>
              <MapItButton onSubmit={onBackFp} text="Back" className="viewbtn"/>
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="preview">
      <Helmet>
        <meta charSet="utf-8" />
        <link rel="canonical" href="https://mapit.cc/preview" />
      </Helmet>
      <PageTitle title="Preview" />
      <Logo/>
      { floorplan && 
      <div className="preview-mapit-fp-outter">
        <div className="preview-floorplan">
          <img src={getFpImageSrc(fpBase64, "")} 
          width={fpWidth*winX} 
          height={fpHeight*winY}
          />
          <div className="preview-snapshots">
          <div>
            {Object.keys(ssObjs).map((ssId, index) => (
              selectedCoord[`coordX: ${ssObjs[ssId].coordinatex} coordY: ${ssObjs[ssId].coordinatey}`] == 0
              ?
              <div>
                <img
                  className="ss-img-img"
                  key={index} 
                  src={getImageSrc(ssObjs[ssId])} 
                  alt="interior home picture"
                  style={{
                    ...{border: "1.5px solid black", 
                    cursor: "pointer",
                    opacity: ssId!==selectedSS?0.5:1,
                    width: getSSWidth(ssId), 
                    height: getSSHeight(ssId)}, 
                    ...getSnapshotStyle(ssId)}} 
                  onClick={() => imageClick(ssId)} 
                />
                {coordMap[`coordX: ${ssObjs[ssId].coordinatex} coordY: ${ssObjs[ssId].coordinatey}`] 
                && coordMap[`coordX: ${ssObjs[ssId].coordinatex} coordY: ${ssObjs[ssId].coordinatey}`] > 1 
                &&
                  <div>
                    <p className="count-style" style={{...getSnapshotCountStyle(ssId)}}>
                      {coordMap[`coordX: ${ssObjs[ssId].coordinatex} coordY: ${ssObjs[ssId].coordinatey}`]}
                    </p>
                  </div>
                }
              </div>
              :
              <div ref={galRef} style={{touchAction:'pinch-zoom', zIndex: 3}}>
                <img
                className="ss-img-img"
                key={index} 
                src={getImageSrc(ssObjs[ssId])} 
                style={{
                  ...{border: "1.5px solid black", 
                  opacity: selectedSS==ssId?1:0,
                  zIndex: 3, 
                  cursor: "pointer", 
                  width: getSSWidth(ssId),
                  height: getSSHeight(ssId)},
                  ...getSnapshotStyle(ssId)}}
                onClick={() => onLargeImageClick(ssId)}
                alt="interior home picture"
                />
                <div className='arrow-image' 
                 onClick={slideRight}
                 onKeyDown={ArrowKeyDetector} 
                 style={{...{position: 'absolute', zIndex: 4, cursor: 'pointer', opacity:selectedSS==ssId?1:0 }, ...getLeftArrowStyle(ssId)}}>
                 <img src={left}
                 style={{width: ((getSSWidth(ssId)*0.1>40)?40:getSSWidth(ssId)*0.1),
                 height: getSSWidth(ssId)*0.1*1.74>69?69:getSSWidth(ssId)*0.1*1.74,
                 position: 'absolute', 
                 top: "50%", 
                 left: "50%", 
                 transform: "translate(-50%,-50%)"}}
                 />
               </div>
               <div className='arrow-image-hover' 
                 onClick={slideRight}
                 onKeyDown={ArrowKeyDetector} 
                 style={{...{position: 'absolute', zIndex: 4, cursor: 'pointer'}, ...getLeftArrowStyle(ssId)}}>
                   <img src={leftBlue}
                   style={{width: ((getSSWidth(ssId)*0.1>40)?40:getSSWidth(ssId)*0.1),
                   height: getSSWidth(ssId)*0.1*1.74>69?69:getSSWidth(ssId)*0.1*1.74,
                   position: 'absolute', 
                   top: "50%", 
                   left: "50%", 
                   transform: "translate(-50%,-50%)"}}
                   />
               </div>
               <div className='arrow-image' 
               onClick={slideLeft} 
               style={{...{position: 'absolute', zIndex: 4, cursor: 'pointer', opacity:selectedSS==ssId?1:0 }, ...getRightArrowStyle(ssId)}}>
                 <img src={right}
                 style={{width: ((getSSWidth(ssId)*0.1>40)?40:getSSWidth(ssId)*0.1),
                 height: getSSWidth(ssId)*0.1*1.74>69?69:getSSWidth(ssId)*0.1*1.74,
                 position: 'absolute', 
                 top: "50%", 
                 left: "50%", 
                 transform: "translate(-50%,-50%)"}}
                 />
               </div>
               <div className='arrow-image-hover' 
                onClick={slideLeft} 
                style={{...{position: 'absolute', zIndex: 4, cursor: 'pointer'}, ...getRightArrowStyle(ssId)}}>
                  <img src={rightBlue}
                  style={{width: ((getSSWidth(ssId)*0.1>40)?40:getSSWidth(ssId)*0.1),
                  height: getSSWidth(ssId)*0.1*1.74>69?69:getSSWidth(ssId)*0.1*1.74,
                  position: 'absolute', 
                  top: "50%", 
                  left: "50%", 
                  transform: "translate(-50%,-50%)"}}
                  />
               </div>
              </div>
            ))}
          </div>
          </div>
        </div>
      </div>
      }
      <Footer create={true}></Footer>
    </div>
  );
}

export default Preview;